<div class="background" [class.visible]="index !== null"></div>

<i class="material-icons close" (click)="doClose()" *ngIf="index !== null">close</i>
<i class="material-icons prev" (click)="goPrevious()" *ngIf="index !== null">navigate_before</i>
<i class="material-icons next" (click)="goNext()" *ngIf="index !== null">navigate_next</i>

<image *ngIf="index !== null" [src]="items[index].image" [class.visible]="index !== null" (swipeleft)="goNext()" (swiperight)="goPrevious()"></image>

<selector [items]="items" [index]="index" (select)="setImage($event)" [class.visible]="index !== null"></selector>
